import React, { useEffect, useLayoutEffect, useState } from 'react';
import { connect } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import logo from '../assets/images/C_logo.png';
import kamiun from '../assets/images/kamiun.png';
import keshande from '../assets/images/keshande.png';
import trailer from '../assets/images/trailer.png';
import keshavarzi from '../assets/images/keshavarzi.png';
import kamiunet from '../assets/images/kamiunet.png';
import komperesi from '../assets/images/komperesi.png';
import otubus from '../assets/images/otubus.png';
import minibus from '../assets/images/minibus.png';
import rahsazi from '../assets/images/rahsazi.png';
import jarsaghil from '../assets/images/jarsaghil.png';
import { updateTerm, updateCategory, clearCategory } from '../actions/vehicleFilters'
import AddHome from '../components/AddHome'
import { clearVehicleList } from '../actions/vehicleAds';

const Home = (props) => {

    const [termValue, setTermValue] = useState("");
    const [isPromped, setPromped] = useState(true);

    useLayoutEffect(() => {
        const query = new URLSearchParams(props.location.search)
        if (!query.has('native')) {
            setPromped(!!localStorage.getItem("prompedHome"))
        }
        else {
            localStorage.setItem("prompedHome", true)
        }
    }, [])

    useEffect(() => {
        props.clearCategory()
        props.clearVehicleList()
    }, [])

    const onTermChange = (e) => {
        setTermValue(e.target.value);
    }

    const onPrompChanged = (e) => {
        setPromped(!isPromped);
    }

    const submitSearch = (e) => {
        if (e.key === "Enter") {
            props.updateCategory("");
            props.updateTerm(termValue);
            props.history.push('/vehicles');
        }
    }

    const igniteSearch = (e) => {
        props.updateCategory("");
        props.updateTerm(termValue);
        props.history.push('/vehicles');
    }

    const onAdvancedSearch = (e) => {
        props.history.push('/vehicle-filters');
    }

    const onGalleriesSearch = (e) => {
        props.history.push('/galleries');
    }

    const chooseCategory = (catId) => {
        props.updateTerm("");
        props.updateCategory(String(catId));
        props.history.push(`/vehicles?catId=${catId}`);
    }

    const onVisitAds = (catId) => {
        props.updateTerm("");
        props.updateCategory(undefined);
        props.history.push('/vehicles');
    }

    const onAddClicked = (e) => {
        props.isAuthenticated
            ?
            props.history.push('/register-vehicle',)
            :
            props.history.push('/login',)
    }

    return (
        <>
            {
                isPromped ? (
                    // <PerfectScrollbar>
                    <div className="container-sm home-container">
                        <div className="optimized__d-flex-class flex-column align-items-center py-4">
                            {/* <img className="image-fluid home__logo mb-3" alt="logo" src={logo}/> */}
                            {/* <span className="home__logo-title">CARCLICK.<span className="home__logo-title--thin">IR</span></span> */}
                            <span className="home__logo-title--main">کارکلیک</span>
                            <span className="home__logo-title">مرکز تخصصی خرید و فروش</span>
                            <span className="home__logo-title">ماشین آلات سنگین</span>
                        </div>
                        <div className='home__btn-container--top'>
                            <div onClick={onAddClicked} className='home-btn--buy'>
                                <i class="material-icons m-2">add</i>
                                <span>فروشنده‌ام</span>
                            </div>
                            <div onClick={onVisitAds} className='home-btn--list'>
                                <i class="material-icons m-2">filter_list</i>
                                <span>خریدارم</span>
                            </div>
                        </div>
                        <div className=" home__search-container optimized__d-flex-class">
                            {/* <span>
                                    <i className="simple-icon-magnifier align-middle home__search-icon px-2"></i>
                                </span> */}
                            <input className="home__search-box flex-grow-1 p-1 align-middle" value={termValue} onChange={onTermChange} onKeyUp={submitSearch} placeholder="دنبال چی میگردی؟" type="text" />
                        </div>
                        <div className='home__btn-container--bottom'>
                            <div onClick={onAdvancedSearch} className='home-btn--filter'>
                                <i class="material-icons m-2">tune</i>
                                <span>جستجوی پیشرفته</span>
                            </div>
                            <div onClick={igniteSearch} className='home-btn--search'>
                                <i class="material-icons m-2">search</i>
                                <span>جستجو</span>
                            </div>
                        </div>
                        <div className='home__btn-container--bottom'>
                            <div onClick={onGalleriesSearch} className='home-btn--list'>
                                <span>شهرک نمایشگاه</span>
                            </div>
                        </div>
                        <div className="home__tile">
                            <div className="optimized__d-flex-class home-grid-root" onClick={(e) => chooseCategory(4)}>
                                <img className="home-grid-img" alt="کامیون" src={kamiun} />
                                <span className="home__item-text text-center align-middle">کامیون</span>
                            </div>
                            <div className="optimized__d-flex-class home-grid-root" onClick={(e) => chooseCategory(3)}>
                                <img className="home-grid-img--small" alt="تریلر" src={trailer} />
                                <span className="home__item-text text-center align-middle">تریلر</span>
                            </div>
                            <div className="optimized__d-flex-class home-grid-root" onClick={(e) => chooseCategory(2)}>
                                <img className="home-grid-img" alt="کشنده" src={keshande} />
                                <span className="home__item-text text-center align-middle">کشنده</span>
                            </div>
                            <div className="optimized__d-flex-class home-grid-root" onClick={(e) => chooseCategory(5)}>
                                <img className="home-grid-img" alt="کامیونت" src={kamiunet} />
                                <span className="home__item-text text-center align-middle">کامیونت</span>
                            </div>
                            <div className="optimized__d-flex-class home-grid-root" onClick={(e) => chooseCategory(8)}>
                                <img className="home-grid-img--small" alt="اتوبوس" src={otubus} />
                                <span className="home__item-text text-center align-middle">اتوبوس</span>
                            </div>
                            <div className="optimized__d-flex-class home-grid-root" onClick={(e) => chooseCategory(10)}>
                                <img className="home-grid-img" alt="راه‌سازی" src={rahsazi} />
                                <span className="home__item-text text-center align-middle">راه‌سازی</span>
                            </div>
                        </div>
                        {/* <div className="optimized__d-flex-class align-items-end justify-content-around mt-3 flex-wrap">
                                <div className="optimized__d-flex-class flex-column align-items-center px-4 py-3 col-3" onClick={(e) => chooseCategory(2)}>
                                    <img className="img-fluid" alt="کشنده" src={keshande}/>
                                    <span className="home__item-text text-center align-middle">کشنده</span>
                                </div>
                                <div className="optimized__d-flex-class flex-column align-items-center px-4 py-3 col-3" onClick={(e) => chooseCategory(3)}>
                                    <img className="img-fluid" alt="تریلر" src={trailer}/>
                                    <span className="home__item-text text-center align-middle">تریلر</span>
                                </div>
                                <div className="optimized__d-flex-class flex-column align-items-center px-4 py-3 col-3" onClick={(e) => chooseCategory(4)}>
                                    <img className="img-fluid" alt="کامیون" src={kamiun}/>
                                    <span className="home__item-text text-center align-middle">کامیون</span>
                                </div>
                                <div class="w-100"></div>
                                <div className="optimized__d-flex-class flex-column align-items-center px-4 py-3 col-3" onClick={(e) => chooseCategory(5)}>
                                    <img className="img-fluid" alt="کامیونت" src={kamiunet}/>
                                    <span className="home__item-text text-center align-middle">کامیونت</span>
                                </div>
                                    <div className="optimized__d-flex-class flex-column align-items-center px-4 py-3 col-3" onClick={(e) => chooseCategory(12)}>
                                    <img className="img-fluid" alt="کانکس" src={komperesi}/>
                                    <span className="home__item-text text-center align-middle">کانکس</span>
                                </div>
                                <div className="optimized__d-flex-class flex-column align-items-center px-4 py-3 col-3" onClick={(e) => chooseCategory(11)}>
                                    <img className="img-fluid" alt="کشاورزی" src={keshavarzi}/>
                                    <span className="home__item-text text-center align-middle">کشاورزی</span>
                                </div>
                                <div className="optimized__d-flex-class flex-column align-items-center px-4 py-3 col-3" onClick={(e) => chooseCategory(9)}>
                                    <img className="img-fluid" alt="مینی‌بوس" src={minibus}/>
                                    <span className="home__item-text text-center align-middle">مینی‌بوس</span>
                                </div>
                                <div class="w-100"></div>
                                <div className="optimized__d-flex-class flex-column align-items-center px-4 py-3 col-3" onClick={(e) => chooseCategory(14)}>
                                    <img className="img-fluid" alt="جرثقیل" src={jarsaghil}/>
                                    <span className="home__item-text text-center align-middle">جرثقیل</span>
                                </div>
                                <div className="optimized__d-flex-class flex-column align-items-center px-4 py-3 col-3" onClick={(e) => chooseCategory(8)}>
                                    <img className="img-fluid" alt="اتوبوس" src={otubus}/>
                                    <span className="home__item-text text-center align-middle">اتوبوس</span>
                                </div>
                                <div className="optimized__d-flex-class flex-column align-items-center px-4 py-3 col-3" onClick={(e) => chooseCategory(10)}>
                                    <img className="img-fluid" alt="راه‌سازی" src={rahsazi}/>
                                    <span className="home__item-text text-center align-middle">راه‌سازی</span>
                                </div>
                                <div class="w-100"></div>
                            </div> */}
                    </div>
                    // </PerfectScrollbar>
                ) : (
                    <AddHome prompSwitcher={onPrompChanged} />
                )
            }
        </>
    )
}

const mapStateToProps = (state, props) => ({
    isAuthenticated: !!state.auth.token
})

const mapDispatchToProps = (dispatch) => ({
    updateTerm: (term) => dispatch(updateTerm({ term })),
    updateCategory: (category) => dispatch(updateCategory({ category })),
    clearCategory: () => dispatch(clearCategory()),
    clearVehicleList: () => dispatch(clearVehicleList())
})

export default connect(mapStateToProps, mapDispatchToProps)(Home);